const help = {

  getByName(itemName, items) {
    let item = null;
    if(items.length > 0) item = items[0];
    for (let i = 0; i < items.length; i++)
      if (itemName === items[i].name)
        item = items[i];
    return item;
  },

  calcPercent(num, percentage){
    const result = num * (percentage / 100);
    return parseFloat(result.toFixed(2));
  },

  randBetween(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min)
  },

  randBelow(num) {
    return Math.floor(Math.random() * num);
  },

  randFromArray(arr) {
    return arr[help.randBelow(arr.length)];
  },

  arrayUnique(array) {
    let a = array.concat();
    for (let i = 0; i < a.length; ++i)
      for (let j = i + 1; j < a.length; ++j) if (a[i] === a[j]) a.splice(j--, 1);

    return a;
  },
  shuffle(array) {
    let currentIndex = array.length,
      temporaryValue,
      randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  },

  capitalize: function (s) {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  },
  isNullOrUndefined: function (x) {
    return (typeof (x) === "undefined" || x == null);
  },
  getDimFromPic: function (imageName, refImages, refPercent, refWidth = null, refHeight = null) {
    let img = refImages[imageName];
    let targetWidth = img.naturalWidth;
    let targetHeight = img.naturalHeight;

    return this.getDim(targetWidth, targetHeight, refPercent, refWidth, refHeight);
  },
  getDim: function (targetWidth, targetHeight, refPercent, refWidth = null, refHeight = null) {
    if (refWidth == null && refHeight == null) refWidth = document.body.clientWidth;

    let imageH,
      imageW = 0;
    if (refHeight != null) {
      const ASPECT = targetWidth / targetHeight;
      imageH = Math.floor(refHeight * refPercent);
      imageW = ASPECT * imageH;
    } else {
      const ASPECT = targetHeight / targetWidth;
      imageW = Math.floor(refWidth * refPercent);
      imageH = ASPECT * imageW;
    }

    return { imageW, imageH };
  },


};

export default help;